export default __webpack_public_path__ + "static/media/icon_avatar.46f4cf63.svg";